<button id={{field.config.id}} (click)="onClick($event)" [disabled]="!field.enabled"
  [class.bl-disabled]="!field.enabled"
  [attr.data-automation-id]="field.automationId"
  class="bl-font-color--primary"
  [ngClass]="field.config.icon? 'bl-button bl-button-tertiary bl-width--100' :'button-anchor bl-text-align--left'">
  <span [ngClass]="field.config.icon? 'bl-display--flex bl-align-items--center bl-justify-content--center' :''">
    <i *ngIf="field.config.icon" class="bl-margin-right--4" [ngClass]="field.config.icon"></i>
    {{ field.label }}
  </span>
</button>